import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardHeader,
  CardContent,
  FormHelperText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import { getAllFacilityList } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

//get DispensingLanguage
const DispensingLanguage = JSON.parse(
  localStorage.getItem("DispensingLanguage"),
);
const lan = localStorage.getItem("LangCode");
const menukey = "user-entry";

const UserInfo = encryptionService.decryptUserInfo();
const userId = UserInfo == 0 ? "" : UserInfo[0].id;

const DispenserFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  const classes = useStyles();

  const { t, i18n } = useTranslation();

  const RoleList = JSON.parse(localStorage.getItem("RoleList"));
  const LanguageList = JSON.parse(localStorage.getItem("LanguageList"));
  //const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getAllFacilityList();

  //====== Start Choosen Dropdown===========
  const [chosenValues, setChosenValues] = useState({
    role_id: null,
    FacilityId: null,
  });

  useEffect(() => {
    let chosenValuesData = { ...chosenValues };
    const roleIdx = RoleList.findIndex(
      (Role_List) => Role_List.id == formData.role_id,
    );
    chosenValuesData["role_id"] = roleIdx >= 0 ? RoleList[roleIdx] : null;
    const facilityIdx = FacilityList.findIndex(
      (Facility_List) => Facility_List.id == formData.FacilityId,
    );
    chosenValuesData["FacilityId"] =
      facilityIdx >= 0 ? FacilityList[facilityIdx] : null;
    setChosenValues(chosenValuesData);
  }, [formData.role_id, formData.FacilityId]);

  const handleChangeChoosen = (name, valueobj, value) => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData[name] = valueobj;
    setChosenValues(chosenValuesData);
    props.handleChangeChoosenProps(name, value);
  };

  //====== End Choosen Dropdown===========

  const getRxLevel = (type = null) => {
    let level = "";
    if (formData.rxLevel) {
      level = formData.rxLevel;
    }
    return level;
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {DispensingLanguage[lan][menukey]["User - Add/Edit"]}
                </div>

                <div className="float-end sw_btn_control">
                  {addProductForm ? (
                    <Grid item xs={12} className="mt-4 text-center">
                      <div className="float-end sw_btn_control">
                        <Button
                          disabled={!!props.permissionType}
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => handleReset()}
                        >
                          {DispensingLanguage[lan][menukey]["Reset"]}
                        </Button>
                        <Button
                          disabled={!!props.permissionType}
                          className="me-2"
                          variant="contained"
                          color="primary"
                          onClick={() => handleSubmit()}
                        >
                          {DispensingLanguage[lan][menukey]["Save"]}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => props.history.push("/user-entry")}
                        >
                          {DispensingLanguage[lan][menukey]["Back to List"]}
                        </Button>
                      </div>
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="mt-2 text-center">
                      <Button
                        disabled={!!props.permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleUpdate()}
                      >
                        {DispensingLanguage[lan][menukey]["Update"]}
                      </Button>

                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/user-entry")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <Card className="sw_card">
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.name}
                  helperText={errorObject.name}
                  required
                  id="name"
                  name="name"
                  label={DispensingLanguage[lan][menukey]["Name"]}
                  value={formData.name}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.email}
                  helperText={errorObject.email}
                  required
                  id="email"
                  name="email"
                  label={DispensingLanguage[lan][menukey]["Email"]}
                  value={formData.email}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.loginname}
                  helperText={errorObject.loginname}
                  required
                  id="loginname"
                  name="loginname"
                  label={DispensingLanguage[lan][menukey]["Login Name"]}
                  value={formData.loginname}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={2} sm={2}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.password}
                  helperText={errorObject.password}
                  required
                  id="password"
                  name="password"
                  type="password"
                  label={DispensingLanguage[lan][menukey]["Password"]}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={2} sm={2}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.confirmChangePassword}
                  helperText={errorObject.confirmChangePassword}
                  id="confirmChangePassword"
                  name="confirmChangePassword"
                  type="password"
                  label={DispensingLanguage[lan][menukey]["Confirm Password"]}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>

              <Grid item xs={4} sm={4}>
                <TextField
                  variant="standard"
                  disabled={!!props.permissionType}
                  error={!!errorObject.designation}
                  helperText={errorObject.designation}
                  required
                  id="designation"
                  name="designation"
                  label={DispensingLanguage[lan][menukey]["Designation"]}
                  value={formData.designation}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => handleChange(e)}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Language"]}*
                  </InputLabel>
                  <Select
                    disabled={!!props.permissionType}
                    error={!!errorObject.LangCode}
                    labelId="demo-simple-select-helper-label"
                    id="LangCode"
                    name="LangCode"
                    value={formData.LangCode || "fr_FR"}
                    fullWidth
                    onChange={(e) => handleChange(e)}
                    label={`${DispensingLanguage[lan][menukey]["Language"]} *`}
                  >
                    {LanguageList.map((item, index) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText error={!!errorObject.LangCode}>
                    {errorObject.LangCode}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={4} sm={4}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <Autocomplete
                    disabled={!!props.permissionType}
                    autoHighlight
                    id="role_id"
                    options={RoleList}
                    onChange={(event, valueobj) =>
                      handleChangeChoosen(
                        "role_id",
                        valueobj,
                        valueobj ? valueobj.id : "",
                      )
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      value?.id == null || option?.id === value?.id
                    }
                    value={chosenValues["role_id"]}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">
                          {option.name}
                        </Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={formData.role_id}
                        label={DispensingLanguage[lan][menukey]["Role"] + " *"}
                        variant="standard"
                        error={!!errorObject.role_id}
                        helperText={errorObject.role_id}
                        id="role_id"
                        name="role_id"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4} sm={4}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <Autocomplete
                    disabled={!!props.permissionType}
                    autoHighlight
                    id="FacilityId"
                    options={FacilityList}
                    onChange={(event, valueobj) =>
                      handleChangeChoosen(
                        "FacilityId",
                        valueobj,
                        valueobj ? valueobj.id : "",
                      )
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      value?.id == null || option?.id === value?.id
                    }
                    value={chosenValues["FacilityId"]}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">
                          {option.name}
                        </Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={formData.FacilityId}
                        label={
                          DispensingLanguage[lan][menukey]["Facility Name"]
                        }
                        variant="standard"
                        error={!!errorObject.FacilityId}
                        helperText={errorObject.FacilityId}
                        id="FacilityId"
                        name="FacilityId"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4} sm={4} className="sw_active_patient">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      disabled={
                        props.permissionType || formData.id == 1 ? true : false
                      }
                      checked={!!Number(formData.IsActive)}
                      onChange={(e) => handleCheck(e)}
                      name="IsActive"
                      value="no"
                    />
                  }
                  label={DispensingLanguage[lan][menukey]["Active"]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
